<div class="collapsible-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.USER" [size]="20"></app-icon>
      <span class="toggle-title">Persönliche Angaben</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="section-form">
      <div class="form-row two-col">
        <div class="form-group">
          <label for="salutation" class="form-label">Anrede</label>
          <select
            id="salutation"
            formControlName="salutation"
            class="form-select"
            [class.is-empty]="!form.value.salutation"
            [class.has-change]="isFieldChanged('salutation')"
          >
            <option value="">Bitte wählen</option>
            @for (option of salutationOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="gender" class="form-label">Geschlecht</label>
          <select
            id="gender"
            formControlName="gender"
            class="form-select"
            [class.is-empty]="!form.value.gender"
            [class.has-change]="isFieldChanged('gender')"
          >
            <option value="">Bitte wählen</option>
            @for (option of genderOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
      </div>

      <div class="form-row two-col">
        <div class="form-group">
          <label for="firstName" class="form-label">Vorname</label>
          <input
            id="firstName"
            type="text"
            formControlName="firstName"
            class="form-input"
            [class.has-change]="isFieldChanged('firstName')"
            placeholder="Vorname"
            maxlength="100"
          />
          @if (hasError('firstName', 'maxlength')) {
            <span class="error-text">Vorname darf höchstens {{ form.get('firstName')?.errors?.['maxlength'].requiredLength }} Zeichen lang sein</span>
          }
        </div>

        <div class="form-group">
          <label for="lastName" class="form-label">Nachname</label>
          <input
            id="lastName"
            type="text"
            formControlName="lastName"
            class="form-input"
            [class.has-change]="isFieldChanged('lastName')"
            placeholder="Nachname"
            maxlength="100"
          />
          @if (hasError('lastName', 'maxlength')) {
            <span class="error-text">Nachname darf höchstens {{ form.get('lastName')?.errors?.['maxlength'].requiredLength }} Zeichen lang sein</span>
          }
        </div>
      </div>

      <div class="form-group">
        <label for="displayName" class="form-label">Anzeigename</label>
        <input
          id="displayName"
          type="text"
          formControlName="displayName"
          class="form-input"
          [class.has-change]="isFieldChanged('displayName')"
          placeholder="Anzeigename (optional)"
          maxlength="100"
        />
        @if (hasError('displayName', 'maxlength')) {
          <span class="error-text">Anzeigename darf höchstens {{ form.get('displayName')?.errors?.['maxlength'].requiredLength }} Zeichen lang sein</span>
        }
      </div>

      <div class="form-group">
        <label for="birthdate" class="form-label">Geburtsdatum</label>
        <input
          id="birthdate"
          type="date"
          formControlName="birthdate"
          class="form-input"
          [class.has-change]="isFieldChanged('birthdate')"
          [attr.max]="todayIso"
        />
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="toggleExpanded()"
          [disabled]="isSaving()"
        >
          {{ hasChanges() ? 'Verwerfen' : 'Abbrechen' }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!form.valid || isSaving() || !hasChanges()"
          [class.btn-loading]="isSaving()"
        >
          @if (isSaving()) {
            Speichern...
          } @else {
            Speichern
          }
        </button>
      </div>
    </form>
  }
</div>
